import debounce from './debounce';
/**
 * @param selectedLat 
 * @param selectedLng 
 * @param data
 * This function create map view with all return points, but restrict with bounds to 
 * avoid too many markers are visible on map
 */
var createMapView = (function (data, selectedLat, selectedLng) {
    // initial map
    initialMap();

    function initialMap(){
        var map = new google.maps.Map(document.getElementById('c-results-map'), {
            center: new google.maps.LatLng(selectedLat, selectedLng),
            zoom : 15,
            streetViewControl: false,
            fullscreenControl: false,
            mapTypeControl: false
        });
        // map centre - suburb centre
        var latLng = new google.maps.LatLng(selectedLat, selectedLng);
        
        // debounce pin to map center by clicking
        var debouncePinToCenter = debounce(function(){
            map.panTo(latLng);
        }, 200);
        // pin to map center when click bottom button
        $('.c-return-point-result--toggle-button button').click(function(){
            debouncePinToCenter();
        });
        /* flag to indicate google maps is loaded */
        var googleMapsLoaded = false;

        /* listen to the tilesloaded event
        if that is triggered, google maps is loaded successfully for sure */
        google.maps.event.addListener(map, 'tilesloaded', function() {
            // control view map button
            $('.c-return-point-result--toggle-button').removeClass('loading');
            $('.c-return-point-result--toggle-button button').removeAttr('disabled');

            googleMapsLoaded = true;

            // pan to map centre when map is created
            map.panTo(latLng);

            // set up zoom level
            var visibleMarkersArr = [];
            if( $(window).width() > 600){
                visibleMarkersArr = data.splice(0, 9);
                setZoomLevel(map, visibleMarkersArr);
            }
            else{
                visibleMarkersArr = data.splice(0, 3);
                setZoomLevel(map, visibleMarkersArr);
            }
            //clear the listener, we only need it once
            google.maps.event.clearListeners(map, 'tilesloaded');
        });
        // Create marker
        createMarker(map, data);
    }
    function setZoomLevel(map, visibleMarkersArr){
        for (var i=0; i<visibleMarkersArr.length; i++){
            var visibleMarkersArrPosition = new google.maps.LatLng (
                                                visibleMarkersArr[i].cp_latitude, 
                                                visibleMarkersArr[i].cp_longitude
                                            );
            if( map.getBounds().contains(visibleMarkersArrPosition) ){
                map.setZoom(map.getZoom());
            }else{
                map.setZoom(map.getZoom() - 1);
            }
        }
    }

    // when infobox is open, push map centre down
    function offsetCenter(map, latlng, offsetx, offsety) {
        // latlng is the apparent centre-point
        // offsetx is the distance you want that point to move to the right, in pixels
        // offsety is the distance you want that point to move upwards, in pixels
        // offset can be negative
        // offsetx and offsety are both optional
        var scale = Math.pow(2, map.getZoom());
    
        var worldCoordinateCenter = map.getProjection().fromLatLngToPoint(latlng);
        var pixelOffset = new google.maps.Point((offsetx/scale) || 0,(offsety/scale) ||0);
    
        var worldCoordinateNewCenter = new google.maps.Point(
            worldCoordinateCenter.x - pixelOffset.x,
            worldCoordinateCenter.y + pixelOffset.y
        );
    
        var newCenter = map.getProjection().fromPointToLatLng(worldCoordinateNewCenter);
    
        map.panTo(newCenter);
    
    }
    function createMarker(map, data){
        var prev_infoWindow;
        var currentURL = window.location.origin;
        var mapCard = new InfoBox({
            boxClass : 'c-return-point-card__map-pin-container',
            disableAutoPan: false,
            pixelOffset:new google.maps.Size(-128, -70),
            alignBottom: true,
            closeBoxURL : window.location.origin + '/wp-content/themes/webling-twig/static/images/icons/icon-close-white.svg'
        });
        var markers = data.map(function(location, i){

            var rpTitle = location.cp_title;
            var rpStatus = location.cp_status;
            var rpType = location.cp_collection_point_type;
            var rpSuburb = location.cp_city;
            var rpOpenCloseStatus = location.cp_open_close_state_messages.map;
            var rpAddress = location.cp_address;
            var rpTypeIconUrl = location.cp_type_icon;
            var rpUrl = location.cp_url;
            var rpDistance = location.cp_distance;
            var rpStatusClass = location.cp_status_class;
            var rpTypeClass = location.cp_collection_point_type.replace(/ /g,"-");
            var iconTypeColor = {
                url: location.cp_map_icon,
                scaledSize: new google.maps.Size(35, 43)
            };

            // Finalize marker.
            var marker = new google.maps.Marker({
                position: new google.maps.LatLng(location.cp_latitude, location.cp_longitude),
                map: map,
                icon: iconTypeColor
            }); 

            // map card content
            var content = 
                "<div class='c-return-point-card__item c-return-point-card__map-pin " + rpTypeClass +"'>\n\
                    <a href='" + rpUrl + "' class='c-return-point-card--link'>\n\
                        <div class='c-return-point-card__top'>\n\
                            <div class='c-return-point-card--status " + rpStatusClass + "'>" + rpStatus + "</div>\n\
                            <div class='c-return-point-card--type__icon'>" + "<img src='"+ rpTypeIconUrl + "' alt='" + rpType + "'></div>\n\
                            <div class='c-return-point-card--type__text'>" + rpType + "</div>\n\
                            <div class='c-return-point-card--name__suburb'><h4>" + rpSuburb + "</h4></div>\n\
                            <div class='c-return-point-card--name__text'>" + rpTitle + "</div>\n\
                            <div class='c-return-point-card--address__mobile'>" + rpAddress + "</div>\n\
                            <div class='c-return-point-card--suburb__mobile'>" + rpSuburb + "</div>\n\
                            <div class='c-return-point-card--openning-hours'>" + rpOpenCloseStatus + "</div>\n\
                        </div>\n\
                        <div class='c-return-point-card__bottom'>\n\
                            <div class='c-return-point-card--address'>" + rpAddress + "</div>\n\
                            <div class='c-return-point-card--distance'>" + rpDistance + " km away</div>\n\
                        </div>\n\
                        <div class='c-return-point-card--map-pointer c-return-point-card--map-pointer__desktop'><img src='" + currentURL + "/wp-content/themes/webling-twig/static/images/card-icons/card-map-pointer.png' alt=''></div>\n\
                        <div class='c-return-point-card--map-pointer c-return-point-card--map-pointer__mobile'><img src='" + currentURL + "/wp-content/themes/webling-twig/static/images/card-icons/card-map-pointer-mobile.png' alt=''></div>\n\
                    </a>\n\
                </div>";

            var content = 
                "<div class='rp-mapmarker'>\n\
                    <h5><span>" + rpTitle + "</span> - <span>" + rpSuburb + "</span></h5>\n\
                    <p>" + rpType + "</p>\n\
                    <p>" + rpAddress + " - " + rpDistance + " km</p>\n\
                    <p class='" + rpStatusClass + "'><strong>" + rpOpenCloseStatus + "</strong></p>\n\
                    <a href='" + rpUrl + "' class='c-button c-button--primary-button'><span>More Info</span></a>\n\
                </div>"


            google.maps.event.addListener(marker, 'click', function(evt) {
                // set up each card content
                mapCard.setContent(content);
                offsetCenter(map, marker.getPosition(), '0', '-500');
                // map.setCenter(marker.getPosition());
                // if( prev_infoWindow != null) {
                //     prev_infoWindow.close();
                //     prev_infoWindow = null;
                // }
                // console.log(marker.getPosition().lat());
                // console.log(marker.getPosition().lng());
                // for(var i =0; i<markers.length; i++){
                //     console.log(markers[i].getPosition().lat());
                //     console.log(markers[i].getPosition().lng());
                // }
                // console.log(marker.getPosition());
                // infoWindow.open(map, marker);
                mapCard.open(map, marker);
                // prev_infoWindow = mapCard;
            });
            
            window.globalMarker.push(marker);
            
            return marker;
        });        
    }
  });
  
  export default createMapView;


// WEBPACK FOOTER //
// ./FE-Build/src/js/modules/createMapView.js